import * as v from 'valibot';
import { publish, TCoreEvents } from '@fe-core-events';
import { useIntl } from 'react-intl';
import { useError } from '@hooks/useError';
import { MethodNotAllowedError } from '@fe-core';

const NotAllowedErrorSchema = v.object({
  id: v.fallback(
    v.union([
      v.literal('ERROR_NOT_INVITABLE'),
      v.literal('UNKNOWN_ERROR'),
      v.literal('ERROR_COURSE_FULL'),
      v.literal('ERROR_PROJECT_ERROR'),
      v.literal('ERROR_CREDITRESERVATION'),
    ]),
    'UNKNOWN_ERROR',
  ),
});

const DefaultErrorDetails = {
  title: 'catalog.course.enroll.error.unknown.title',
  description: 'catalog.course.enroll.error.unknown.description',
  status: 'error',
};

const notAllowedErrorMap = {
  ERROR_NOT_INVITABLE: {
    title: 'catalog.course.enroll.error.not.published.title',
    description: 'catalog.course.enroll.error.not.published.description',
    status: 'error',
  },
  ERROR_COURSE_FULL: {
    title: 'catalog.course.enroll.confirmation.overlimit.title',
    description: 'catalog.course.enroll.confirmation.overlimit.description',
    status: 'error',
  },
  ERROR_PROJECT_ERROR: DefaultErrorDetails,
  ERROR_CREDITRESERVATION: {
    title: 'catalog.course.enroll.error.creditreservation.title',
    description: 'catalog.course.enroll.error.creditreservation.description',
    status: 'warning',
  },
  UNKNOWN_ERROR: DefaultErrorDetails,
};

export const useEnrollmentError = (_error: Error | null) => {
  const intl = useIntl();
  const emitError = useError();

  if (!_error) {
    return null;
  }

  let errorDetails = DefaultErrorDetails;

  if (_error instanceof MethodNotAllowedError) {
    const message = JSON.parse(_error.message);
    const notAllowedError = v.safeParse(NotAllowedErrorSchema, message);
    if (!notAllowedError.success) {
      emitError({
        error: _error,
        errorMapOverride: {
          type: 'modal',
        },
      });

      return;
    }

    const error = notAllowedError.output;
    errorDetails = notAllowedErrorMap[error.id];
  }

  const eventName = `feedback.ui.${errorDetails.status}.base` as TCoreEvents;
  publish({
    eventName,
    data: {
      consumer: 'fe-learner-catalog',
      event: eventName,
      type: 'modal',
      status: errorDetails.status,
      config: {
        title: intl.formatMessage({
          id: errorDetails.title,
        }),
        description: intl.formatMessage({
          id: errorDetails.description,
        }),
      },
      action: {
        event: '',
        type: 'close',
        text: {
          title: intl.formatMessage({ id: 'learner.common.close' }),
        },
      },
    },
  });
};
